<ngx-spinner></ngx-spinner>

@if (!exitingSurvey) {
  @if(!showMaskImage) {
    <div class="c-survey__hero">
      <img src={{imagePath}} id="maskImage" />
    </div>
  }

  <div class="c-survey__section c-splash-screen">
    @if(showMaskImage) {
      <div class="mask">
        <img style="max-height: 200px" src={{imagePath}} />
      </div>
    }
    <h1 id="greeting" class="c-splash-screen__title">{{dialogObj.Title | translate: { firstName: firstName} }}</h1>

    <div class="dialog-description">
      <span id="dialog_description" [innerHTML]="dialogObj.Description | translate"></span>
    </div>

    @if (dialogObj.HasDynamicList) {
      <div class="dialog-list">
        <span>
          @for (item of dialogObj.DynamicList; track item) {
            <div class="dialog-list-item">
              <li><span [innerHTML]="item | translate"></span></li>
            </div>
          }
        </span>
      </div>
    }

    @if (dialogObj.HasFollowUpDescription) {
      <div class="dialog-description">
        <span id="dialog_follow-up-description" [innerHTML]="dialogObj.FollowUpDescription | translate"></span>
      </div>
    }

    @if (dialogObj.ShowPrivacyPolicy) {
      <div class="privacy-container c-survey__help">
        <div class="material-icons-outlined privacy-icon">verified_user</div>
      <div class="privacy-statement" [innerHTML]="dialogObj.PrivacyPolicy | translate"></div>
      </div>
    }
  </div>
}
